import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { person } from '@config';

const StyledSection = styled.section`
  ${({ theme }) => theme.mixins.section};
  background: var(--paper-soft);
  border-top: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
`;

const StyledInner = styled.div`
  ${({ theme }) => theme.mixins.container};
  display: grid;
  grid-template-columns: 1.15fr 0.85fr;
  gap: 64px;
  align-items: center;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

const StyledText = styled.div`
  h2 {
    margin-bottom: 6px;
  }

  .role {
    margin: 0 0 22px;
    color: var(--blue);
    font-size: var(--fz-lg);
    font-weight: 600;
  }

  p {
    max-width: 620px;
    color: var(--text-soft);
  }

  .actions {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    margin-top: 28px;
  }

  .primary {
    ${({ theme }) => theme.mixins.primaryButton};
  }

  .secondary {
    ${({ theme }) => theme.mixins.secondaryButton};
  }
`;

const StyledCard = styled.div`
  position: relative;
  overflow: hidden;
  padding: 40px 34px;
  border-radius: var(--radius-xl);
  background: var(--ink-900);
  background-image: radial-gradient(420px 260px at 85% 0%, rgba(86, 112, 246, 0.4), transparent 60%),
    radial-gradient(360px 260px at 0% 100%, rgba(253, 118, 255, 0.22), transparent 60%);
  color: var(--on-dark-soft);
  box-shadow: var(--shadow-card);

  .avatar {
    ${({ theme }) => theme.mixins.flexCenter};
    width: 88px;
    height: 88px;
    margin-bottom: 22px;
    border-radius: 50%;
    background: var(--gradient);
    color: #ffffff;
    font-size: 30px;
    font-weight: 700;
    letter-spacing: 0.04em;
  }

  h3 {
    margin: 0 0 4px;
    color: #ffffff;
    font-size: var(--fz-xxl);
  }

  .position {
    margin: 0 0 22px;
    color: var(--blue-soft);
    font-size: var(--fz-sm);
  }

  ul {
    ${({ theme }) => theme.mixins.resetList};
    display: grid;
    gap: 12px;

    li {
      position: relative;
      padding-left: 22px;
      color: var(--on-dark);
      font-size: var(--fz-sm);
      line-height: 1.5;

      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0.55em;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: var(--gradient);
      }
    }
  }
`;

/**
 * Вместо стоковой фотографии используется фирменный знак и инициалы.
 * Чтобы поставить реальное фото специалиста, добавьте файл
 * src/images/maria-pushkareva.jpg и замените блок .avatar на <StaticImage />.
 */
const About = () => (
  <StyledSection id="about">
    <StyledInner>
      <StyledText>
        <p className="eyebrow">О специалисте</p>
        <h2>{person.name}</h2>
        <p className="role">{person.role}</p>
        <p>
          Работает в ЮУрГУ, кандидат экономических наук, доцент кафедры «Системное
          программирование» Института естественных и точных наук. Более 5 лет занимается разработкой
          программного обеспечения и управлением IT-проектами.
        </p>
        <p>
          Специализация охватывает управление IT-проектами, создание сайтов, разработку мобильных
          приложений и веб-сервисов, применение искусственного интеллекта и защиту информации.
        </p>

        <div className="actions">
          <Link className="primary" to="/about">
            Подробнее о специалисте
          </Link>
          <Link className="secondary" to="/contacts">
            Получить консультацию
          </Link>
        </div>
      </StyledText>

      <StyledCard>
        <div className="avatar" aria-hidden="true">
          {person.initials}
        </div>
        <h3>{person.name}</h3>
        <p className="position">{person.academic} · ЮУрГУ</p>
        <ul>
          <li>Доцент кафедры «Системное программирование» ИЕТН</li>
          <li>Кандидат экономических наук</li>
          <li>Более 5 лет в разработке и управлении IT-проектами</li>
          <li>Преподаватель разработки, внедрения и сопровождения ПО</li>
        </ul>
      </StyledCard>
    </StyledInner>
  </StyledSection>
);

export default About;
